import { Button, ColorPicker, Slider } from "antd";
import { memo, useState } from "react";
import styled from "styled-components";
import { MdClose } from "react-icons/md";

interface StyleCircleProps {
    layer: any;
    onDeleted: () => void;
}
const StyleCircle = (props: StyleCircleProps) => {
    const [circleColor, setCircleColor] = useState<string>(props.layer.paint['circle-color']);
    const [circleRadius, setCircleRadius] = useState<number>(props.layer.paint['circle-radius']);
    const [circleStrokeColor, setCircleStrokeColor] = useState<string>('#fff');
    const [circleStrokeWidth, setCircleStrokeWidth] = useState<number>(2);

    return <>
        <UI_Wrapper>
            <UI_Title_Wrapper>
                <UI_Content_Title>
                    {`Điểm (${props.layer['source-layer']})`}
                </UI_Content_Title>
                <Button type="text" style={{ padding: 8 }} onClick={() => {
                    props.onDeleted();
                    window.map?.removeLayer(props.layer.id);
                }}>
                    <MdClose color="red" />
                </Button>
            </UI_Title_Wrapper>

            <UI_Content_Row>
                <UI_Content_Row_Label>Màu điểm</UI_Content_Row_Label>
                <UI_Content_Row_Value>
                    <ColorPicker
                        value={circleColor}
                        onChange={(value) => {
                            window.map?.setPaintProperty(props.layer.id, 'circle-color', value.toHexString());
                            setCircleColor(value.toHexString());
                        }}
                    />
                </UI_Content_Row_Value>
            </UI_Content_Row>

            <UI_Content_Row>
                <UI_Content_Row_Label>Kích thước (px)</UI_Content_Row_Label>
                <UI_Content_Row_Value>
                    <Slider
                        style={{ width: '100%' }}
                        value={circleRadius}
                        onChange={(value) => {
                            window.map?.setPaintProperty(props.layer.id, 'circle-radius', value);
                            setCircleRadius(value);
                        }}
                        min={1}
                        max={30}
                    />
                </UI_Content_Row_Value>
            </UI_Content_Row>

            <UI_Content_Row>
                <UI_Content_Row_Label>Màu viền</UI_Content_Row_Label>
                <UI_Content_Row_Value>
                    <ColorPicker value={circleStrokeColor} onChange={(value) => {
                        window.map?.setPaintProperty(props.layer.id, 'circle-stroke-color', value.toHexString());
                        setCircleStrokeColor(value.toHexString())
                    }}
                    />
                </UI_Content_Row_Value>
            </UI_Content_Row>

            <UI_Content_Row>
                <UI_Content_Row_Label>Độ dày viền</UI_Content_Row_Label>
                <UI_Content_Row_Value>
                    <Slider style={{ width: '100%' }} value={circleStrokeWidth} onChange={(value) => {
                        window.map?.setPaintProperty(props.layer.id, 'circle-stroke-width', value);
                        setCircleStrokeWidth(value)
                    }} min={1} max={10} />
                </UI_Content_Row_Value>
            </UI_Content_Row>
        </UI_Wrapper>
    </>;
}

export default memo(StyleCircle);

const UI_Wrapper = styled.div`
    padding: 8px;
`

const UI_Title_Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 8px;
`

const UI_Content_Title = styled.div`
    font-size: 13px;
    font-weight: 600;
    margin-right: 8px;
`

const UI_Content_Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 8px;
`
const UI_Content_Row_Label = styled.div`
    font-size: 14px;
    margin-right: 8px;
    color: #666666;
    flex: 1;
`
const UI_Content_Row_Value = styled.div`
    flex: 1;
`